(function () {
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var iconMenu = document.querySelector('[data-icon-menu]');
  var iconClose = document.querySelector('[data-icon-close]');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = !menu.classList.contains('hidden');
      menu.classList.toggle('hidden', isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (iconMenu && iconClose) {
        iconMenu.classList.toggle('hidden', !isOpen);
        iconClose.classList.toggle('hidden', isOpen);
      }
    });
  }

  if (header) {
    var onScroll = function () {
      header.classList.toggle('shadow-[0_4px_30px_rgba(204,171,102,0.2)]', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Cart badge/aria-label sync is fully owned by window.Velo.updateCartUI
  // (assets/checkout-selected-variant.js), called from cart-drawer.js and
  // the shared checkout action - no separate listener needed here.

  var navItems = document.querySelectorAll('[data-nav-item]');
  var isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var closeAllNavItems = function () {
    navItems.forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = item.querySelector('[data-nav-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  // Fine-pointer (mouse) devices: the main <a> always navigates on one
  // click/tap (no listener attached to it at all), and the dropdown opens
  // purely via CSS :hover/:focus-within - completely unchanged from before.
  // Touch/coarse-pointer devices: the chevron button is revealed and takes
  // over opening/closing the dropdown, so the main <a> stays a plain,
  // single-tap link.
  if (navItems.length && !isFinePointer) {
    navItems.forEach(function (item) {
      var toggle = item.querySelector('[data-nav-dropdown-toggle]');
      if (!toggle) return;

      toggle.classList.remove('hidden');
      toggle.classList.add('inline-flex');

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeAllNavItems();
        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      navItems.forEach(function (item) {
        if (!item.contains(event.target)) {
          item.classList.remove('is-open');
          var toggle = item.querySelector('[data-nav-dropdown-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (navItems.length) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllNavItems();
      }
    });
  }
})();
